'use client';

import Layout from '@/components/Layout';
import useCart from '@/utils/useCart';
import { useAppSelector } from '@/lib/hooks';
import style from '../../components/Products/ProductList.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import { useState, useEffect, useRef } from 'react';
import { PreLoader } from '@/components/preloader/PreLoader';
import CategoriesMenuLoader from '@/components/CategoryMenus/CategoryMenuWrapper';
import { usePathname } from 'next/navigation';
import CategoryWiseProducts from '@/components/CategorywiseProducts/CategorywiseProducts';
import { useRouter } from 'next/navigation';
import ProductBox from '@/components/Products/ProductBox';
import { Helmet, HelmetProvider } from 'react-helmet-async';

export default function Products() {
	const router = useRouter();

	const { addToCart, reduceProductQuantity, increaseProductQuantity } =
		useCart();
	const cartItems = useAppSelector((state) => state.cartItems.cartItems);

	const [allProducts, setAllProducts] = useState([]);
	const [page, setPage] = useState(1);
	const [screenWidth, setScreenWidth] = useState(
		typeof window !== 'undefined' ? window.innerWidth : null
	);
	const [isHovered, setIsHovered] = useState(false);
	const marqueeRef = useRef(null);

	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		fetchProducts();
	}, [currentPage]);

	const fetchProducts = async () => {
		const userData = JSON.parse(localStorage.getItem('pharma_customer'));

		try {
			setIsLoading(true);
			const apiUrl = `${process.env.NEXT_PUBLIC_BACKEND_URL}${
				process.env.NEXT_PUBLIC_PHARMA_ALL_PRODUCTS
			}?country=${
				process.env.NEXT_PUBLIC_COUNTRY_CODE
			}&category=A03&warehouse=&search=&page=${currentPage}&location=${
				userData ? userData?.location : ''
			}`;
			await fetch(apiUrl, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => response.json())
				.then((result) => {
					// Extracting the locations array from the response object
					const allProductsArray = result && result.data ? result.data : [];

					if (Array.isArray(allProductsArray)) {
						const filteredProducts = allProductsArray.filter((prod) => {
							return (
								prod.total_inventory > 0 && prod.pharma_product_uoms.length > 0
							);
						});
						setAllProducts(filteredProducts);
						setTotalPages(result.meta.last_page);
						// setCurrentPage(result.meta.current_page);
					} else {
						console.error('Invalid locations data:', result);
					}
					setIsLoading(false);
				})
				.catch((error) => {
					setIsLoading(false);
					console.error('Fetch error:', error);
				});
		} catch (error) {
			console.error('Error fetching products:', error);
		}
	};

	const handleNextPage = () => {
		window.scrollTo(0, 0);
		if (currentPage < totalPages) {
			setCurrentPage((prevPage) => prevPage + 1);
		}
	};

	const handlePrevPage = () => {
		window.scrollTo(0, 0);
		if (currentPage > 1) {
			setCurrentPage((prevPage) => prevPage - 1);
		}
	};

	const handlePageChange = (pageNumber) => {
		window.scrollTo(0, 0);
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setCurrentPage(pageNumber);
		}
	};

	useEffect(() => {
		const handleResize = () => {
			setScreenWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
	const maxLength = 200;

	function stripHtmlTags(htmlString, maxLength) {
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = htmlString;
		let textContent = tempDiv.textContent || tempDiv.innerText || '';
		// Truncate to 200 characters
		if (textContent.length > maxLength) {
			textContent = textContent.substring(0, maxLength) + '...';
		}
		return textContent;
	}

	return (
		<>
			<Layout>
				<HelmetProvider>
					<Helmet>
						<title>Kasha Products</title>
						<meta name='description' content='Kasha Products' />
						<link
							rel='canonical'
							href={
								process.env.NEXT_PUBLIC_COUNTRY_CODE === 'KE'
									? 'https://pharma.kasha.co.ke/shop'
									: 'https://pharma.kasha.rw/shop'
							}
						/>
					</Helmet>
				</HelmetProvider>

				<div
					style={{
						marginRight: 'auto',
						marginLeft: 'auto',
						padding: '1rem',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexDirection: 'column',
					}}>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'flex-start',
							fontSize: '12px',
							fontWeight: '500',
							marginBottom: '1rem',
							width: '82%',
							marginLeft: '0rem',
						}}>
						<div>
							<Link href='/'>
								<Image
									src='/images/arrow-left-02-sharp.svg'
									height={20}
									width={20}
									alt='back'
									style={{ marginRight: '5px', cursor: 'pointer' }}
								/>
							</Link>
						</div>
						<div>Home / </div>&nbsp;
						<div style={{ color: '#e2156a' }}> Products</div>
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							flexWrap: 'wrap',
						}}>
						{isLoading ? (
							<PreLoader />
						) : (
							allProducts &&
							allProducts.map((product, index) => (
								<div key={index} style={{ height: '232px' }}>
									<ProductBox product={product} />
								</div>
							))
						)}
					</div>
					<div>
						<button
							className={style.prevButton}
							onClick={handlePrevPage}
							disabled={currentPage === 1}>
							Previous
						</button>
						&nbsp;
						{Array.from({ length: totalPages }, (_, index) => index + 1).map(
							(pageNumber) => (
								<button
									key={pageNumber}
									style={
										pageNumber === currentPage
											? { backgroundColor: '#e2156a', color: '#fff' }
											: null
									}
									onClick={() => handlePageChange(pageNumber)}>
									{pageNumber}
								</button>
							)
						)}
						&nbsp;
						<button
							className={style.nextButton}
							onClick={handleNextPage}
							disabled={currentPage === totalPages}>
							Next
						</button>
					</div>
				</div>
			</Layout>

			{/* )} */}
		</>
	);
}
